import { Skeleton, Table, TableContainer } from '@mui/material'

import { Box, Flex } from '@grupoboticario/flora-react'

import TableHeader from '@/components/Table/Generic/TableHeader/TableHeader'
import { FadeIn } from '@/utils/useFadeIn/useFadeIn'

import * as S from './BackofficeTableContainer.styles'

const BackofficeTableContainer = ({ children, loading, columns, rows = 6 }) =>
  loading ? (
    <FadeIn>
      <TableContainer>
        <Table>
          <TableHeader columns={columns} />
        </Table>
        <Box css={S.skeletonTableCss}>
          <Flex css={S.skeletonColumnsCss} direction="column" gap="$1">
            {Array.from({ length: rows }, (__, rowIndex) => (
              <Flex
                align="center"
                as={Skeleton}
                css={S.skeletonRowCss}
                height={48}
                key={`skeleton-row-${rows}-${rowIndex}`}
                style={{ maxWidth: '100%' }}
                variant="rect"
              >
                {columns.map((column) => (
                  <Box css={S.skeletonCellCss(column.minWidth)} key={column.id}>
                    <Skeleton
                      animation={false}
                      height={24}
                      style={{ visibility: 'initial', width: '80%' }}
                      variant="text"
                    />
                  </Box>
                ))}
              </Flex>
            ))}
          </Flex>
        </Box>
      </TableContainer>
    </FadeIn>
  ) : (
    <FadeIn>
      <TableContainer>{children}</TableContainer>
    </FadeIn>
  )

export default BackofficeTableContainer
